import { render, staticRenderFns } from "./ContentItemsEditTabOverview.vue?vue&type=template&id=2173a102&"
import script from "./ContentItemsEditTabOverview.vue?vue&type=script&lang=js&"
export * from "./ContentItemsEditTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./ContentItemsEditTabOverview.vue?vue&type=style&index=0&id=2173a102&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports